export const labels = {
	autofillTooltip: {
		label: "Label.MobileCreator.Autofill.Tooltip",
		default: "Want to quickly fill in some photos? Tap here and we'll do it for you!",
	},
} as const;
